import type {Context} from '../types';

const defaultTagSelectorStyleBlockIdRegex = /^default-[a-z0-6]+$/;
const isNotTagStyleBlockId = (styleBlockId: string) =>
  !defaultTagSelectorStyleBlockIdRegex.test(styleBlockId);

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const originalClasses = jsonNode.classes;

  const classesWithoutTagStyleBlockIds = originalClasses
    ? originalClasses.filter(isNotTagStyleBlockId)
    : originalClasses;

  const hasTagStyleBlockIdsInClasses =
    classesWithoutTagStyleBlockIds && originalClasses
      ? classesWithoutTagStyleBlockIds.length < originalClasses.length
      : false;

  return {
    needed: hasTagStyleBlockIdsInClasses,
    logData: {
      msg: 'Node has tag style block IDs in its `classes` array',
      meta: {
        jsonNode,
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode.classes = classesWithoutTagStyleBlockIds;
    },
  };
};
